import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';

// --- LE ROUTEUR DU CHAOS ---
// Met à jour l'URL (#hash), sauvegarde la destination, puis délègue à appliquerNavigation.

export function naviguer(vue, data = {}) {
    let hash = vue;
    if (vue === 'sphere' && data.id) {
        hash = `sphere/${data.id}`;
    } else if (vue === 'mp') {
        const identifiant = data.id || data.pseudo;
        if (identifiant) hash = `mp/${identifiant}`;
    }

    if (vue === 'dashboard' || vue === 'sphere') {
        // Nettoyer les bulles MP et le header quand on quitte les conversations privées.
        // Ces fonctions restent dans app.js (dépendent de variables locales) → window.
        if (typeof window.supprimerBullesMPLues === 'function') window.supprimerBullesMPLues();
        if (typeof window.nettoyerHeaderGlobal === 'function') window.nettoyerHeaderGlobal();
    }

    history.pushState({ section: vue, details: data }, "", "#" + hash);
    localStorage.setItem('derniereVue', JSON.stringify({ vue, data }));
    appliquerNavigation(vue, data);
}

export function clicSurSphere(idSphere) {
    naviguer('sphere', { id: idSphere });
}

export function appliquerNavigation(vue, data = {}) {
    localStorage.setItem('derniereVue', JSON.stringify({ vue, data }));

    const headerElement = document.getElementById('chat-header');
    if (!headerElement) return;

    const loginView      = document.getElementById('login-view');
    const registerView   = document.getElementById('register-view');
    const chatScreen     = document.getElementById('chat-screen');
    const authScreen     = document.getElementById('auth-screen');
    const vueSocial      = document.getElementById('vue-social');
    const vueDashboard   = document.getElementById('dashboard-accueil');
    const vueChat        = document.getElementById('chat-view');
    const colSalons      = document.getElementById('channels-column');
    const authError      = document.getElementById('auth-error');
    const verifyEmailView  = document.getElementById('verify-email-view');
    const googleSetupView  = document.getElementById('google-setup-view');

    if (authError) authError.textContent = "";

    if (vue === 'login' || vue === 'register' || vue === 'verify' || vue === 'google-setup') {
        authScreen.style.display = 'flex';
        chatScreen.style.display = 'none';
        loginView.style.display    = (vue === 'login')    ? 'block' : 'none';
        registerView.style.display = (vue === 'register') ? 'block' : 'none';
        if (verifyEmailView) verifyEmailView.style.display = (vue === 'verify')        ? 'block' : 'none';
        if (googleSetupView) googleSetupView.style.display = (vue === 'google-setup')  ? 'block' : 'none';
    } else {
        authScreen.style.display = 'none';
        chatScreen.style.display = 'flex';

        // Contexte du sidebar agents : 'sphere' si on est dans une sphère, 'global' sinon.
        // En quittant une sphère, on redemande l'annuaire amis (rien d'autre ne le redéclenche).
        const _ctxAvant = state.sidebarContexte;
        state.sidebarContexte = (vue === 'sphere') ? 'sphere' : 'global';
        if (state.sidebarContexte === 'global' && _ctxAvant === 'sphere') {
            socket.emit('demander-liste-maj');
        }

        if (vueSocial)   vueSocial.style.display   = 'none';
        if (vueDashboard) vueDashboard.style.display = 'none';
        if (vueChat)     vueChat.style.display      = 'none';
        if (colSalons) {
            colSalons.style.display = 'none';
            colSalons.classList.remove('open');
        }

        const _avecMessages = (vue === 'sphere' || vue === 'mp' || vue === 'chat');
        majVisibiliteEpingles(_avecMessages);

        if (vue === 'dashboard') {
            headerElement.innerText = t('chat.header_station');
            if (vueDashboard) vueDashboard.style.display = 'block';
            majVisibiliteRecherche(false);
            if (typeof window.ouvrirAccueil === 'function') window.ouvrirAccueil();
        } else if (vue === 'social') {
            headerElement.innerText = t('chat.header_annuaire');
            if (vueSocial) vueSocial.style.display = 'block';
            majVisibiliteRecherche(false);
            socket.emit('demander-liste-amis');
        } else if (vue === 'sphere' || vue === 'mp' || vue === 'chat') {
            if (vueChat) vueChat.style.display = 'flex';

            if (vue === 'sphere' && data.id) {
                if (colSalons) colSalons.style.display = 'block';
                if (data.salonId) {
                    try {
                        const _mSeed = JSON.parse(localStorage.getItem('chaos_derniers_salons') || '{}');
                        if (!_mSeed[data.id]) {
                            _mSeed[data.id] = { salonId: data.salonId, salonNom: data.salonNom };
                            localStorage.setItem('chaos_derniers_salons', JSON.stringify(_mSeed));
                        }
                    } catch(e) {}
                }
                if (typeof window.rejoindreSphere === 'function') window.rejoindreSphere(data.id, data.nom);
            } else if (vue === 'mp' && data.pseudo) {
                if (typeof window.ouvrirChatPrive === 'function') window.ouvrirChatPrive(data.pseudo);
            }
        }
    }

    if (typeof window.majPushChannels === 'function') window.majPushChannels();
    majVisibiliteBandeauAppel(vue, data);
}

// Bouton "Précédent" du navigateur
window.addEventListener('popstate', (event) => {
    if (event.state) {
        appliquerNavigation(event.state.section, event.state.details);
    } else {
        naviguer('login');
    }
});

// --- VISIBILITÉ BANDEAU APPEL MP ---

export function majVisibiliteBandeauAppel(vue, data) {
    const banner = document.getElementById('mp-call-banner');
    if (!banner || !banner.dataset.cible) return;
    const estSurLeBonMP = (vue === 'mp' && data && data.pseudo === banner.dataset.cible);
    banner.style.display = estSurLeBonMP ? 'flex' : 'none';
}

// --- VISIBILITÉ DE LA RECHERCHE ---

export function majVisibiliteRecherche(visible) {
    const btn = document.getElementById('btn-search');
    if (!btn) return;
    btn.style.display = visible ? 'inline-block' : 'none';
    if (!visible && typeof window.fermerRecherche === 'function') window.fermerRecherche();
}

export function majVisibiliteEpingles(visible) {
    const btn = document.getElementById('btn-pins');
    if (!btn) return;
    btn.style.display = visible ? '' : 'none';
    if (!visible) {
        const panel = document.getElementById('pins-side-panel');
        if (panel) panel.style.display = 'none';
    }
}

// ==========================================================================
//   NAVIGATION MOBILE (boutons bas + swipe)
// ==========================================================================

export function toggleMobileChannels() {
    if (window.innerWidth > 768) { window.toggleSidebarMenu?.(); return; }

    const channels  = document.getElementById('channels-column');
    const sphereNav = document.getElementById('chaos-sidebar-nav');
    const channelsOpen  = channels?.classList.contains('mobile-open');
    const sphereNavOpen = sphereNav?.classList.contains('mobile-open');

    closeMobileOverlays();

    if (channels && channels.style.display !== 'none') {
        if (!channelsOpen) {
            channels.classList.add('mobile-open');
            document.getElementById('mobile-overlay')?.classList.add('visible');
        }
    } else {
        if (!sphereNavOpen) {
            sphereNav?.classList.add('mobile-open');
            document.getElementById('mobile-overlay')?.classList.add('visible');
        }
    }
}

export function toggleMobileAgents() {
    if (window.innerWidth > 768) { window.toggleAgents?.(); return; }
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;
    const isOpen = sidebar.classList.toggle('mobile-open');
    document.getElementById('mobile-overlay')?.classList.toggle('visible', !!isOpen);
}

export function toggleMobileSettings() {
    if (window.innerWidth > 768) { window.toggleAgents?.(); return; }
    closeMobileOverlays();
    window.toggleSettings?.();
}

export function closeMobileOverlays() {
    document.getElementById('channels-column')?.classList.remove('mobile-open');
    document.querySelector('.sidebar')?.classList.remove('mobile-open');
    document.getElementById('chaos-sidebar-nav')?.classList.remove('mobile-open');
    document.getElementById('mobile-overlay')?.classList.remove('visible');
}

export function syncMobileOverlay() {
    if (window.innerWidth > 768) return;
    const channels = document.getElementById('channels-column');
    const agentsSidebar = document.querySelector('.sidebar');
    const isOpen = channels?.classList.contains('mobile-open')
                || agentsSidebar?.classList.contains('mobile-open');
    document.getElementById('mobile-overlay')?.classList.toggle('visible', !!isOpen);
}

// Fermer le tiroir de nav quand on clique sur un item (mobile)
document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('chaos-sidebar-nav')?.addEventListener('click', e => {
        if (window.innerWidth > 768) return;
        const isNavItem = e.target.closest('.sphere-icon, .home-chaos-btn, .sphere-btn-wrapper, [data-sphere-id]');
        if (isNavItem) setTimeout(closeMobileOverlays, 180);
    });
});

// ── Swipe gestures mobile ──────────────────────────────────────────────────
(function () {
    let _tsX = 0, _tsY = 0, _tsActive = false;
    const SEUIL    = 55;  // px minimum pour valider un swipe
    const BORD_MAX = 40;  // px depuis le bord gauche pour déclencher l'ouverture

    document.addEventListener('touchstart', e => {
        if (window.innerWidth > 768) return;
        const t = e.touches[0];
        _tsX = t.clientX; _tsY = t.clientY; _tsActive = true;
    }, { passive: true });

    document.addEventListener('touchend', e => {
        if (!_tsActive || window.innerWidth > 768) return;
        _tsActive = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - _tsX;
        const dy = t.clientY - _tsY;

        if (Math.abs(dx) < SEUIL || Math.abs(dy) > Math.abs(dx) * 0.8) return;

        const channelsVisible = document.getElementById('channels-column')?.style.display !== 'none';

        if (dx > 0 && _tsX <= BORD_MAX && channelsVisible) {
            const channels = document.getElementById('channels-column');
            if (channels && !channels.classList.contains('mobile-open')) {
                channels.classList.add('mobile-open');
                document.getElementById('mobile-overlay')?.classList.add('visible');
            }
        } else if (dx < 0) {
            const channels = document.getElementById('channels-column');
            const agents   = document.querySelector('.sidebar');
            const nav      = document.getElementById('chaos-sidebar-nav');
            const anyOpen  = channels?.classList.contains('mobile-open')
                          || agents?.classList.contains('mobile-open')
                          || nav?.classList.contains('mobile-open');
            if (anyOpen) closeMobileOverlays();
        }
    }, { passive: true });
})();
